import { ApiService } from '@/api/services/core/ApiService';
import ENDPOINTS from '@/api/endpoints';
import { TaxPayersQueryParams } from '@/api/services/types';
import { axiosInstance } from '@/api/axios';

export class BusinessService extends ApiService {
  public getTaxpayersList(params: TaxPayersQueryParams) {
    return axiosInstance.get<any>(ENDPOINTS.taxPayers.index, {
      params: { ...params },
    });
  }

  public getPartnersList(params: TaxPayersQueryParams) {
    return axiosInstance.get<any>(ENDPOINTS.partners.index, {
      params,
    });
  }
}
